
<script>
	import listBase from '@_system/components/base/list.vue'
	export default {
		extends: listBase,
		name: 'customizedproductorderIndex',
		props: {

		},
		data() {
			return {
				moduleName: 'customizedproductorder',
				windowName: '定制产品订单',
				windowType: 'modal',
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {

		},
		components: {
			
		}
	}
</script>
